import { render, staticRenderFns } from "./Shopinfo.vue?vue&type=template&id=8229a604&"
import script from "./Shopinfo.vue?vue&type=script&lang=js&"
export * from "./Shopinfo.vue?vue&type=script&lang=js&"
import style0 from "./Shopinfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports